import { useMutation, useQueryClient } from "@tanstack/react-query";
import { refundInvoice } from "@/api/v1-jwt/transaction/transaction";

export function useIssueRefund() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: refundInvoice,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["invoices"] });
      queryClient.invalidateQueries({ queryKey: ["transactions"] });
    },
  });
}
